<template>
    <form action="" class="comment" id="commentForm" :class="{'comment--wide' : techChatsIds.some(el => el === channelId)}">
        <span v-for="(typingUser, index) in typingUsers">
            {{ typingUser.user_name }}<span v-if="index != typingUsers.length - 1">, </span>
        </span>
        <span v-if="typingUsers.length > 0">
            <span v-if="typingUsers.length == 1"> {{ $t('typing_one') }}</span>
            <span v-else> {{ $t('typing_more_than_one') }}</span>
        </span>

        <div style="visibility:hidden; opacity:0" id="dropzone">
            <div id="textnode" v-html="$t('drag_n_drop')"></div>
        </div>

        <button type="button" class="button button--hollow button--choose-groups"
                @click="openModal"
                v-if="techChatButton"
        >
            <img :src="env.public_base + '/assets/images/groups-icon.svg'" alt="">
            <span v-if="!groupLength">{{ $t('choose_groups') }}</span>
            <span class="choose-groups__items-text" v-if="groupLength">{{ $t('choosen_groups_options') }}:</span>
            <span v-if="groupLength">{{ groupLength}}</span>
        </button>

        <div v-if="uploadedFile && showUploadedFile" class="uploaded_file">
            <span class="uploaded_file-text">{{ uploadedFile.name }} </span>
            <span class="uploaded_file-stub">file</span>
            <span class="remove_file_button" @click="removeFile">&times;</span>
        </div>

        <app-ckeditor v-model="content" :config="config" @addMessage="addMessage" @onTyping="onTyping"></app-ckeditor>

        <div class="form-field form-field--textarea">
            <textarea class="field__textarea"
                      name="message"
                      v-model="message"
                      :placeholder="$t('your_message')"
            >
            </textarea>
        </div>

        <div class="controls">
            <div class="controls__container">
                <div class="form-field form-field--file">

                    <label for="messageFileInput" class="field__label">
                        <img :src="env.public_base + '/assets/images/clip-icon.svg'" alt="">
                        <span class="attachment-file__text">{{ $t('attach_file') }}</span>
                    </label>

                    <input type="file" class="field__input field__input--file" id="messageFileInput"
                           @change="attachFile" ref="messageFileInput">
                </div>

                <label class="form-field__label--whiteboard" for="js-file" v-if="allowedRole">
                    <input type="checkbox" id="js-file" class="button button--whiteboard"
                           @change="getWhiteboardStatus"
                           v-model="whiteboard.checkbox"/>
                    <img :src="env.public_base + '/assets/images/whiteboard-icon.svg'" alt="">

                    <span>{{ $t('invite_to_whiteboard') }}</span>
                </label>

              <div class="form-field form-field--file">

                <app-audio-record
                    @audio-captured="audioMessageAttach"
                    ref="audioRec"
                ></app-audio-record>

              </div>

            </div>

            <button type="button" class="button button--send" @click="addMessage">
                <img :src="env.public_base + '/assets/images/send-icon.svg'" alt="">
            </button>
        </div>

        <app-notification-alert v-if="notification && notification.isActive"></app-notification-alert>
    </form>
</template>

<script>

import {mapGetters} from 'vuex';
import io from 'socket.io-client';
import env from '../../env';
import Ckeditor from '../../common_components/VCkeditor.vue';
import NotificationAlert from '../../common_components/NotificationAlert.vue';
import eventBus from "../../courses/eventBus";
import AudioRecord from "../../common_components/AudioRecordMessage";

export default {
        components: {
            appCkeditor: Ckeditor,
            appNotificationAlert:
            NotificationAlert,
            appAudioRecord: AudioRecord,
        },
        data: () => ({
            socket: null,
            previousSocketId: null,
            message: '',
            env,
            content: '',
            config: {
                enterMode: CKEDITOR.ENTER_BR,
                shiftEnterMode: CKEDITOR.ENTER_P,
                autoParagraph: false,
                extraPlugins: 'emoji',
                toolbarGroups: [
                    {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
                    '/',
                    {name: 'insert', groups: ['insert']},
                ],
                height: '80px',
                removeButtons: 'Save,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Strike,Subscript,Superscript,CopyFormatting,RemoveFormat,Outdent,Indent,Blockquote,CreateDiv,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,BidiLtr,BidiRtl,Language,Anchor,Flash,Image,Table,HorizontalRule,Smiley,SpecialChar,Iframe,PageBreak,Maximize,ShowBlocks,About'
            },
            whiteboard: {
                checkbox: false,
                id: null
            },
            uploadedFile: null,
            showUploadedFile: true,
            uploadedFiles: {},
            typingUsers: [],
            file_validation_error: null,
            filename: null,
            checkTypingInterval: null,
            allowed_extensions: [
                '.ogg',
                '.wav',
                '.wma',
                '.7z',
                '.rar',
                '.tar.gz',
                '.zip',
                '.csv',
                '.xml',
                '.tar',
                '.gif',
                '.ico',
                '.jpeg',
                '.jpg',
                '.png',
                '.svg',
                '.css',
                '.htm',
                '.html',
                '.xhtml',
                '.ods',
                '.xlr',
                '.xls',
                '.xlsx',
                '.avi',
                '.flv',
                '.h264',
                '.mov',
                '.mp3',
                '.mp4',
                '.mpg',
                '.mpeg',
                '.wmv',
                '.doc',
                '.docx',
                '.odt',
                '.pdf',
                '.rtf',
                '.txt',
                '.webm'
            ]
        }),
        computed: {
            ...mapGetters([
                'loggedIn',
                'loggedInHash',
                'channelId',
                'noConnection',
                'userData',
                'channelMembers',
                'channelCurrentMembers',
                'courses',
                'personalChats',
                'mainChat',
                'messages',
                'techChat',
                'techChatsIds',
                'schoolGroups',
                'notification',
            ]),
            allowedRole() {
                return this.userData.role === "teacher"
            },
            groupLength() {
                return this.techChatGroups ? Object.keys(this.techChatGroups).length : 0
            },
            editMessage() {
                return this.mainChat.editMessage
            },
            file() {
                return this.mainChat.sentFile
            },
            isUploaded() {
                return this.mainChat.isUploaded
            },
            techChatGroups() {
                return this.mainChat.techChatGroups
            },
            techChatButton() {
                return this.techChatsIds.some(el => el === this.channelId) ? this.userData.role !== 'admin' ||
                    this.userData.role !== 'modarator' || this.userData.role !== 'teacher' : false
            },
        },
        watch: {
            editMessage() {
                this.content = this.editMessage.text;
            },
            file() {
                this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'isUploaded', value: true});
                if (this.uploadedFile !== null && this.uploadedFile !== '') {
                    this.sendFile(this.file.hash, this.file.id);
                }
            },
            '$route'(to, from) {
                if (this.previousSocketId !== this.channelId) {
                    this.previousSocketId = this.channelId;
                    this.socket.emit('leave', {room: this.previousSocketId, token: localStorage.getItem('token')});
                }
            },
            'channelId'(val) {
                if(val){
                    this.leaveRoom();
                    let $vm = this;
                    if(this.socket) {
                        $vm.socket.emit('join', {room: $vm.channelId, token: localStorage.getItem('token')});
                        this.checkTypingInterval = setInterval(this.checkTypingUsers, 4000);
                    }
                }
            },
        },
        methods: {
            createSocket() {
                this.leaveRoom();

                this.socket = io(this.env.socket_url, {
                    transportOptions: {
                        polling: {
                            extraHeaders: {
                                'token': localStorage.getItem('token')
                            }
                        }
                    }
                });

                let $vm = this;

                $vm.socket.on('typing', (msg) => {
                    let typingMember = $vm.channelCurrentMembers[msg['user_id']];

                    if(this.techChatsIds.some(el => el === this.channelId)) return;
                    if ($vm.userData.id !== typingMember['id']) {
                        let typingUserIndex = $vm.typingUsers.findIndex(i => i.user_id === typingMember['id']);
                        if (typingUserIndex === -1) {
                            $vm.typingUsers.push({
                                'user_id': typingMember['id'],
                                'user_name': typingMember['first_name'] + ' ' + typingMember['last_name'],
                                'date': new Date()
                            });
                        }
                    }
                });
            },
            set_all_messages_read() {
                this.$store.dispatch('setAllMessagesRead', {
                    'channel_id': this.channelId,
                    'lang': localStorage.getItem('language')
                });
            },
            leaveRoom() {
                if (this.socket) {
                    this.socket.emit('leave', {room: this.previousSocketId, token: localStorage.getItem('token')});
                    clearInterval(this.checkTypingInterval);
                }
            },
            onTyping() {
                this.socket.emit('typing', {room: this.channelId, token: localStorage.getItem('token')});
            },
            addMessage() {                
                if(this.editMessage.changed) return this.editMessageContent() ;
                if (this.content !== '' || this.uploadedFile) {
                    if (navigator.onLine) {
                        this.file_validation_error = false;
                        if (typeof this.uploadedFile !== 'undefined' && this.uploadedFile !== null && this.uploadedFile !== '') {
                            this.uploadedFiles[this.file.hash] = this.uploadedFile;
                            this.filename = this.uploadedFiles[this.file.hash]['name'].toLowerCase();
                            this.fileValidation(this.file.hash, this.uploadedFiles[this.file.hash]);
                        }

                        if (this.file_validation_error) return;

                        this.content = this.content.replace(/\\/g, "\\\\");

                        let msgHash = '_' + this.userData.id + '_' + this.channelId + '_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

                        let student_groups_ids = [];


                        if(this.techChatsIds.some(el => el === this.channelId)) {
                            if(this.techChatGroups !== null) {
                                this.techChatGroups.forEach(group => student_groups_ids.push(group.id));
                            }

                            if(!this.techChatGroups || !this.techChatGroups.length) {
                                this.schoolGroups.forEach(group => student_groups_ids.push(group.id));
                            }
                        }

                        let paramsToSocket = {
                            room: this.channelId,
                            text: this.content,
                            token: localStorage.getItem('token'),
                            msgHash: msgHash,
                            uploadedFile: Boolean(this.uploadedFile),
                            student_groups_ids: student_groups_ids.join(),
                        };

                        if(this.whiteboard.id) {
                            paramsToSocket.text = paramsToSocket.text + `#wb=${this.whiteboard.id}#`;
                        }

                        if(this.whiteboard.checkbox && this.whiteboard.id) {
                            paramsToSocket['whiteboard'] = this.whiteboard.id
                        }

                        console.log(paramsToSocket, "sent data to socket");
                        this.socket.emit('my room event', paramsToSocket);

                        const colors = 'font-weight: bold;letter-spacing: 6px; font-size: 35px;color: black; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)';
                        console.log(`%c ${this.content} `, colors, ` - content of the message, | ${this.channelId} | - channelId`);

                        this.content = '';
                        this.uploadedFiles[msgHash] = this.uploadedFile;
                        this.showUploadedFile = false;
                        this.whiteboard.checkbox = false;
                        this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'techChatGroups', value: null});

                        this.whiteboard.id = null;
                        this.whiteboard.checkbox = false;

                        this.$refs.audioRec.fileExists = false;
                    } else {
                        this.$store.dispatch('setNoConnection', true);
                    }
                }
            },
            editMessageContent() {
                let params = {
                    room: this.channelId,
                    message_id: this.editMessage.messageId,
                    text: this.content,
                    token: localStorage.getItem('token'),
                    student_groups_ids: this.editMessage.student_groups_ids
                };
                console.log(params, "params before edit message");
                this.socket.emit('edit_message_event', params);

                let data = { text: '', messageId: null, changed: false, student_groups_ids: [] };
                this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'editMessage', value: data});
            },
            pinMessage(msg) {
                let data = {
                    room: this.channelId,
                    messageId: msg.messageId,
                    text: msg.text && msg.text,
                    token: localStorage.getItem('token'),
                    pin: msg.pin,
                    author: {
                        first_name: msg.author && msg.author.first_name,
                        last_name: msg.author && msg.author.last_name,
                        patronymic: msg.author && msg.author.patronymic,
                    },
                    created: msg.created,
                    student_groups_ids: msg.student_groups_ids,
                };
                this.socket.emit('pin_message_event', data);
            },
            sendFile(msgHash, chatMessageId) {
                return new Promise((resolve, reject) => {
                    let form_data = new FormData();
                    if (this.uploadedFile || this.isUploaded) {
                        this.file_validation_error = false;
                        if (this.uploadedFile !== null && this.uploadedFile !== '') {
                            this.fileValidation(this.file.hash, this.uploadedFile);
                            this.filename = this.uploadedFiles[msgHash]['name'];
                        }
                        if (!this.file_validation_error) {

                            form_data.append('file', this.uploadedFiles[msgHash]);
                            form_data.append('chat_message_id', chatMessageId);
                            form_data.append('lang', localStorage.getItem('language'));

                            let params = {loader: true, chatMessageId: chatMessageId};
                            this.$store.dispatch('fileLoader', params);

                            this.$store.dispatch('sendFile', form_data).then(response => {
                                if (response.data.success) {
                                    let params = {loader: false, chatMessageId: chatMessageId};
                                    this.$store.dispatch('fileLoader', params);
                                }
                                resolve(true)
                            }, err => {
                                let params = {loader: false, chatMessageId: chatMessageId};
                                this.$store.dispatch('fileLoader', params);
                                let msg = (((((err || {}).err || {}).response || {}).data || {}).error_description || {})[0];
                                if (typeof msg === 'undefined') {
                                    msg = this.$t('send_file_fail');
                                }
                                this.showNotificationAlert(msg);

                                let messages = this.messages;
                                messages[chatMessageId]['fileState'] = {
                                    error: true,
                                    index: chatMessageId,
                                };
                                this.$store.commit('SET_MESSAGES', messages);
                                reject(err)
                            });
                        }
                        delete this.uploadedFiles[msgHash];
                        this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'scrollable', value: false});
                        this.$refs.messageFileInput.value = '';
                        this.uploadedFile = '';
                    }
                });

            },
            fileValidation(msgHash, file) {
                let ext = this.filename.split('.');
                if (this.filename !== null && !this.allowed_extensions.includes(`.${ext[ext.length - 1]}`)) {
                    this.showNotificationAlert(this.$t('attach_validation_error1'));
                    this.file_validation_error = true;
                }
                // 100mb 104857600
                // 1GB 8589934592
                if (file['size'] > 8589934592) {
                    this.showNotificationAlert(this.$t('attach_validation_error3'));
                    this.file_validation_error = true;
                }
            },
            showNotificationAlert(text) {
                this.$store.commit('SET_NOTIFICATION_ALERT', {text: text, isActive: true});
            },
            attachFile() {
                let file_data = document.getElementById("messageFileInput").files[0];
                if (typeof file_data !== "undefined") {
                    this.uploadedFile = file_data;
                    this.showUploadedFile = true;
                }
            },
            uploadFiles: function (f) {
                let $vm = this;

                function loadFile(file) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        $vm.uploadedFile = file;
                        $vm.showUploadedFile = true;
                    };
                    reader.readAsText(file, "UTF-8");
                }

                for (let i = 0; i < f.length; i++) {
                    if (i > 0) {
                        this.showNotificationAlert(this.$t('only_1_file'));
                    } else {
                        loadFile(f[i]);
                    }
                }
            },
            removeFile() {
                this.uploadedFile = null;
                this.$refs.audioRec.fileExists = false;
            },
            hideNotificationAlert() {
                this.$store.commit('SET_NOTIFICATION_ALERT',  {});
            },
            checkTypingUsers() {
                let $vm = this;
                let now = new Date();
                let checkDate = new Date(now.getTime() - 4000);
                $vm.typingUsers.forEach(function (item, i) {
                    if (item.date < checkDate) {
                        $vm.typingUsers.splice(i, 1);
                    }
                });
            },
            openModal() {
                this.$store.commit('SET_MODAL_STATE', {modal: 'chooseGroups', prop: 'isActive', value: true});
            },
            getWhiteboardStatus() {
                if(this.whiteboard.checkbox) {
                    this.$store.dispatch('getWhiteboardStatus').then(data => {
                        console.log(data.room_id, "room_id");
                        this.whiteboard.id = data.room_id
                    }, err => {
                        this.whiteboard.checkbox = false;
                        let msg = this.$t('whiteboard_fail_create');
                        this.showNotificationAlert(msg);
                    })
                }
            },
          audioMessageAttach(blob) {
            this.uploadedFile = new File([blob], "voice.webm", {
              type: "audio/webm",
            });
            this.showUploadedFile = true;
          }
        },
        created() {
            this.createSocket();
        },
        mounted() {
            let $vm = this;
            window.addEventListener("dragenter", function (e) {
                document.querySelector("#dropzone").style.visibility = "";
                document.querySelector("#dropzone").style.opacity = 1;
                document.querySelector("#textnode").style.fontSize = "48px";
            });

            window.addEventListener("dragleave", function (e) {
                e.preventDefault();
                document.querySelector("#dropzone").style.visibility = "hidden";
                document.querySelector("#dropzone").style.opacity = 0;
                document.querySelector("#textnode").style.fontSize = "42px";
            });

            window.addEventListener("dragover", function (e) {
                e.preventDefault();
                document.querySelector("#dropzone").style.visibility = "";
                document.querySelector("#dropzone").style.opacity = 1;
                document.querySelector("#textnode").style.fontSize = "48px";
            });

            window.addEventListener("drop", function (e) {
                e.preventDefault();
                document.querySelector("#dropzone").style.visibility = "hidden";
                document.querySelector("#dropzone").style.opacity = 0;
                document.querySelector("#textnode").style.fontSize = "42px";

                let files = e.dataTransfer.files;
                $vm.uploadFiles(files);
            });

            eventBus.$on('pin_message', msg => {
                console.log(msg, "msg");
                console.log(msg.student_groups_ids, "student_groups_ids after bus");
                this.pinMessage(msg);
            });
        },
        beforeDestroy() {
            eventBus.$off();
        },
        destroyed() {
            this.leaveRoom();
            this.socket.emit('leave', {room: this.channelId, token: localStorage.getItem('token')});
            console.log(this.channelId,"destoyed room");
            clearInterval(this.checkTypingInterval);
        },
    }
</script>

<style lang="scss">
    .main-section {
        max-height: calc(100vh - 290px);
    }

    .cke_bottom {
        display: none !important;
    }

    .cke_toolbar {
        float: right !important;
    }

    .form-field.form-field--textarea {
        display: none !important;
    }

    div#dropzone {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999999999;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        transition: visibility 175ms, opacity 175ms;
        display: table;
        text-shadow: 1px 1px 2px #000;
        color: #fff;
        background: rgba(0, 0, 0, 0.45);
        font: bold 42px Oswald, DejaVu Sans, Tahoma, sans-serif;

        @media screen and (max-width: 767px){
            display: none
        }
    }

    div#textnode {
        display: table-cell;
        text-align: center;
        vertical-align: middle;
        transition: font-size 175ms;
    }

    .remove_file_button {
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        line-height: .6;
        position: relative;
        top: 3px;
        cursor: pointer;
    }
    .choose-groups__items {
        position: absolute;
        left: 200px;
        top: 14px;

        .choose-groups__items-text {
            @media screen and (max-width: 768px) {
                display: none;
            }
        }
    }


    .button--choose-groups + .uploaded_file {
        left: 230px;

        @media screen and (max-width: 768px) {
            left: 50px;
            top: 137px;
        }
    }
    .uploaded_file {
        height: 0px;
        width: 50%;
        position: relative;
        top: 13px;
        left: 14px;
    }




</style>
